import React from 'react'
import ssAndSLogo from '../../../images/SSandS_transparent.png'
import useInApp from '../../hooks/useInApp'
import './Footer.css'

const Footer = () => {
	const { inWrapper } = useInApp()

	return (
		<div
			className='site-footer'
			style={{ backgroundColor: '#3b4044', margin: 0 }}
		>
			<footer style={{ margin: 0, padding: 0 }}>
				<div style={{ margin: 0, padding: 0 }}>
					<div className='row m-0'>
						<div className='col text-center p-0'>
							<div>
								<img src={ssAndSLogo} className='sssLogo' alt='SS&S Logo' />
							</div>

							<div className='py-2'>
								<a
									href='https://www.facebook.com/people/Shirey-Stats-and-Standings/61552872652609/'
									target='_blank'
									rel='noreferrer'
									style={{ color: '#edcb37' }}
								>
									<i className='fa fa-facebook-square fa-4x'></i>
								</a>
							</div>

							{!inWrapper && (
								<div
									className='copyright'
									style={{
										padding: '16px 0 8px 0',
										color: 'white',
										backgroundColor: '#768795',
										margin: 0,
										fontWeight: 'bold',
										fontSize: '1.05rem',
									}}
								>
									Go Ad-Free! Download the App Today!
								</div>
							)}

							{!inWrapper && (
								<div
									className='copyright'
									style={{
										padding: '16px 0 8px 0',
										color: 'white',
										backgroundColor: '#768795',
										margin: 0,
									}}
								>
									A Web Application by{' '}
									<a
										href='https://www.shireystatsandstandings.com/#'
										target='_blank'
										rel='noreferrer'
										style={{ color: 'white' }}
									>
										Shirey Stats and Standings, LLC
									</a>
								</div>
							)}

							<div
								className='copyright'
								style={{
									padding: '8px 0 24px 0',
									color: 'white',
									backgroundColor: '#768795',
									margin: 0,
								}}
							>
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										gap: '12px',
										flexWrap: 'wrap',
									}}
								>
									<a
										href='https://apps.apple.com/us/app/shirey-tournament-tracker/id6752502941'
										target='_blank'
										rel='noreferrer'
									>
										<img
											src='https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg'
											alt='Download on the App Store'
											className='store-badge'
										/>
									</a>

									<a
										href='https://play.google.com/store/apps/details?id=app.web.shireytournamenttracker.app132474&hl=en_US'
										target='_blank'
										rel='noreferrer'
									>
										<img
											src='https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg'
											alt='Get it on Google Play'
											className='store-badge'
										/>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</footer>
		</div>
	)
}

export default Footer
